
import React from "react";
import "./WindowCleaningService.css";

const WindowCleaningService = () => {
  return (
    <div className="window-cleaning-container">
      <h1>Let the Light Back In</h1>
      <p>
        Clean windows brighten any room and leave a lasting impression. Our Window Cleaning
        service removes streaks, smudges, and buildup for crystal-clear results, inside and out.
      </p>

      <h2>What’s Included:</h2>
      <ul>
        <li>Interior and exterior window washing</li>
        <li>Cleaning of sills and tracks</li>
        <li>Cobweb removal from frames</li>
        <li>Optional screen cleaning</li>
      </ul>

      <h2>Why Choose Us for Window Cleaning?</h2>
      <ul>
        <li>🌞 <strong>Streak Free Shine</strong> – We leave windows sparkling, not smeared.</li>
        <li>🪟 <strong>Gentle on Glass, Tough on Dirt</strong> – We use professional tools and safe, effective products.</li>
        <li>🧗 <strong>Hard to Reach? No Problem.</strong> – We handle high windows with care and caution.</li>
        <li>🎯 <strong>Boost Curb Appeal</strong> – Perfect for open houses, special events, or everyday beauty.</li>
        <li>📞 <strong>Quick, Reliable Scheduling</strong> – Book easily, clean quickly.</li>
      </ul>
    </div>
  );
};

export default WindowCleaningService;
